/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "ha": {
        "nu": ["latn"],
        "year": {
          "0": "bana",
          "1": "badi",
          "future": {
            "other": "+{0} y"
          },
          "past": {
            "other": "-{0} y"
          },
          "-1": "bara"
        },
        "year-short": {
          "0": "bana",
          "1": "badi",
          "future": {
            "other": "+{0} y"
          },
          "past": {
            "other": "-{0} y"
          },
          "-1": "bara"
        },
        "year-narrow": {
          "0": "bana",
          "1": "badi",
          "future": {
            "other": "+{0} y"
          },
          "past": {
            "other": "-{0} y"
          },
          "-1": "bara"
        },
        "quarter": {
          "0": "wannan kwatan",
          "1": "kwata na gaba",
          "future": {
            "other": "+{0} Q"
          },
          "past": {
            "other": "-{0} Q"
          },
          "-1": "kwatan karshe"
        },
        "quarter-short": {
          "0": "wannan kwatan",
          "1": "kwata na gaba",
          "future": {
            "other": "+{0} Q"
          },
          "past": {
            "other": "-{0} Q"
          },
          "-1": "kwatan karshe"
        },
        "quarter-narrow": {
          "0": "wannan kwatan",
          "1": "kwata na gaba",
          "future": {
            "other": "+{0} Q"
          },
          "past": {
            "other": "-{0} Q"
          },
          "-1": "kwatan karshe"
        },
        "month": {
          "0": "wannan watan",
          "1": "wata na gaba",
          "future": {
            "other": "+{0} m"
          },
          "past": {
            "other": "-{0} m"
          },
          "-1": "watan daya gabata"
        },
        "month-short": {
          "0": "wannan watan",
          "1": "wata na gaba",
          "future": {
            "other": "+{0} m"
          },
          "past": {
            "other": "-{0} m"
          },
          "-1": "watan da ya gabata"
        },
        "month-narrow": {
          "0": "wannan watan",
          "1": "wata na gaba",
          "future": {
            "other": "+{0} m"
          },
          "past": {
            "other": "-{0} m"
          },
          "-1": "watan da ya gabata"
        },
        "week": {
          "0": "wannan satin",
          "1": "sati na gaba",
          "future": {
            "other": "+{0} w"
          },
          "past": {
            "other": "-{0} w"
          },
          "-1": "satin da ya gabata"
        },
        "week-short": {
          "0": "wannan satin",
          "1": "sati na gaba",
          "future": {
            "other": "+{0} w"
          },
          "past": {
            "other": "-{0} w"
          },
          "-1": "satin da ya gabata"
        },
        "week-narrow": {
          "0": "wannan satin",
          "1": "sati na gaba",
          "future": {
            "other": "+{0} w"
          },
          "past": {
            "other": "-{0} w"
          },
          "-1": "satin da ya gabata"
        },
        "day": {
          "0": "yau",
          "1": "gobe",
          "future": {
            "other": "+{0} d"
          },
          "past": {
            "other": "-{0} d"
          },
          "-1": "jiya"
        },
        "day-short": {
          "0": "yau",
          "1": "gobe",
          "future": {
            "other": "+{0} d"
          },
          "past": {
            "other": "-{0} d"
          },
          "-1": "jiya"
        },
        "day-narrow": {
          "0": "yau",
          "1": "gobe",
          "future": {
            "other": "+{0} d"
          },
          "past": {
            "other": "-{0} d"
          },
          "-1": "jiya"
        },
        "hour": {
          "0": "wannan awa",
          "future": {
            "one": "cikin {0} awa",
            "other": "cikin {0} awa"
          },
          "past": {
            "one": "{0} awa da ya gabata",
            "other": "{0} awa da ya gabata"
          }
        },
        "hour-short": {
          "0": "wannan awa",
          "future": {
            "one": "cikin {0} awa",
            "other": "cikin {0} awa"
          },
          "past": {
            "one": "{0} awa da ya gabata",
            "other": "{0} awa da ya gabata"
          }
        },
        "hour-narrow": {
          "0": "wannan awa",
          "future": {
            "one": "cikin {0} awa",
            "other": "cikin {0} awa"
          },
          "past": {
            "one": "{0} awa da ya gabata",
            "other": "{0} awa da ya gabata"
          }
        },
        "minute": {
          "0": "wannan mintin",
          "future": {
            "one": "cikin {0} minti",
            "other": "cikin {0} minti"
          },
          "past": {
            "one": "{0} minti da ya gabata",
            "other": "{0} minti da ya gabata"
          }
        },
        "minute-short": {
          "0": "wannan mintin",
          "future": {
            "one": "cikin {0} minti",
            "other": "cikin {0} minti"
          },
          "past": {
            "one": "{0} minti da ya gabata",
            "other": "{0} minti da ya gabata"
          }
        },
        "minute-narrow": {
          "0": "wannan mintin",
          "future": {
            "one": "cikin {0} minti",
            "other": "cikin {0} minti"
          },
          "past": {
            "one": "{0} minti da ya gabata",
            "other": "{0} minti da ya gabata"
          }
        },
        "second": {
          "0": "yanzu",
          "future": {
            "one": "cikin {0} dakika",
            "other": "cikin {0} dakika"
          },
          "past": {
            "one": "{0} dakika da ya gabata",
            "other": "{0} dakika da ya gabata"
          }
        },
        "second-short": {
          "0": "yanzu",
          "future": {
            "one": "cikin {0} dakika",
            "other": "cikin {0} dakika"
          },
          "past": {
            "one": "{0} dakika da ya gabata",
            "other": "{0} dakika da ya gabata"
          }
        },
        "second-narrow": {
          "0": "yanzu",
          "future": {
            "one": "cikin {0} dakika",
            "other": "cikin {0} dakika"
          },
          "past": {
            "one": "{0} dakika da ya gabata",
            "other": "{0} dakika da ya gabata"
          }
        }
      }
    },
    "availableLocales": ["ha-GH", "ha-NE", "ha"],
    "aliases": {
      "ha-Latn-GH": "ha-GH",
      "ha-Latn-NE": "ha-NE",
      "ha-Latn-NG": "ha-NG"
    },
    "parentLocales": {}
  });
}